import { AccomodationEnum } from '../../types/enums/accomodation-type/accomodation-type'
import { LanguageEnum } from '../../types/enums/languages/language.enum'
import { AcademicZoneEnum } from '../../types/enums/staff/academic-zone.enum'
import { StaffPositionEnum } from '../../types/enums/staff/staff-position.enum'
import { StaffQualificationEnum } from '../../types/enums/staff/staff-qualifications.enum'
import { DiplomaEnum } from '../../types/enums/staff-application/diploma.enum'
import { StaffFilters } from '../../types/models/staff/staff'

export const transformStaffFiltersToUrl = (filters?: StaffFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.diplomas && filters.diplomas.length)
    searchParams.append('diplomas', filters.diplomas.join(','))

  if (filters.IDF !== undefined) searchParams.append('IDF', filters.IDF ? 'true' : 'false')

  if (filters.languages && filters.languages.length)
    searchParams.append('languages', filters.languages.join(','))

  if (filters.academicZone) searchParams.append('academicZone', filters.academicZone.toString())

  if (filters.position && filters.position.length)
    searchParams.append('position', filters.position.join(','))

  if (filters.qualifications && filters.qualifications.length)
    searchParams.append('qualifications', filters.qualifications.join(','))

  if (filters.radIds && filters.radIds.length)
    searchParams.append('radIds', filters.radIds.join(','))

  if (filters.countriesWishList && filters.countriesWishList.length)
    searchParams.append('countriesWishList', filters.countriesWishList.join(','))

  if (filters.active !== undefined)
    searchParams.append('active', filters.active ? 'true' : 'false')

  if (filters.accountActive !== undefined)
    searchParams.append('accountActive', filters.accountActive ? 'true' : 'false')

  if (filters.countries && filters.countries.length)
    for (const country of filters.countries) searchParams.append('countries', country)

  if (filters.formulaIds && filters.formulaIds.length)
    searchParams.append('formulaIds', filters.formulaIds.join(','))

  if (filters.maxAge) searchParams.append('maxAge', filters.maxAge.toString())

  if (filters.minAge) searchParams.append('minAge', filters.minAge.toString())

  if (filters.periodIds && filters.periodIds.length)
    searchParams.append('periodIds', filters.periodIds.join(','))

  if (filters.accomodations && filters.accomodations.length)
    searchParams.append('accomodations', filters.accomodations.join(','))

  if (filters.transportMeansIds && filters.transportMeansIds.length)
    searchParams.append('transportMeansIds', filters.transportMeansIds.join(','))

  if (filters.availability) {
    if (filters.availability.startDate)
      searchParams.append('availability_start', filters.availability.startDate.toString())
    if (filters.availability.endDate)
      searchParams.append('availability_end', filters.availability.endDate.toString())
  }

  if (filters.departure) {
    if (filters.departure.startDate)
      searchParams.append('departure_start', filters.departure.startDate.toString())
    if (filters.departure.endDate)
      searchParams.append('departure_end', filters.departure.endDate.toString())
  }

  if (filters.arrival) {
    if (filters.arrival.startDate)
      searchParams.append('arrival_start', filters.arrival.startDate.toString())
    if (filters.arrival.endDate)
      searchParams.append('arrival_end', filters.arrival.endDate.toString())
  }

  if (filters.stay) {
    if (filters.stay.startDate)
      searchParams.append('stay_start', filters.stay.startDate.toString())
    if (filters.stay.endDate) searchParams.append('stay_end', filters.stay.endDate.toString())
  }

  if (filters.excludedStaffIds && filters.excludedStaffIds.length)
    searchParams.append('excludedStaffIds', filters.excludedStaffIds.join(','))

  if (filters.staffRequestId)
    searchParams.append('staffRequestId', filters.staffRequestId.toString())

  if (filters.deactivated)
    searchParams.append('deactivated', filters.deactivated ? 'true' : 'false')

  return searchParams.toString()
}

export const transformUrlToStaffFilters = (searchParams: URLSearchParams): StaffFilters => {
  const filters: StaffFilters = {}

  const diplomas = searchParams.get('diplomas')
  if (diplomas && diplomas.length) filters.diplomas = diplomas.split(',') as DiplomaEnum[]

  const IDF = searchParams.get('IDF')
  if (IDF) filters.IDF = IDF === 'true'

  const languages = searchParams.get('languages')
  if (languages && languages.length) filters.languages = languages.split(',') as LanguageEnum[]

  const academicZone = searchParams.get('academicZone')
  if (academicZone) filters.academicZone = academicZone as AcademicZoneEnum

  const position = searchParams.get('position')
  if (position && position.length) filters.position = position.split(',') as StaffPositionEnum[]

  const qualifications = searchParams.get('qualifications')
  if (qualifications && qualifications.length)
    filters.qualifications = qualifications.split(',') as StaffQualificationEnum[]

  const radIds = searchParams.get('radIds')
  if (radIds && radIds.length) filters.radIds = radIds.split(',').map((id) => +id)

  const countriesWishListIds = searchParams.get('countriesWishList')
  if (countriesWishListIds && countriesWishListIds.length)
    filters.countriesWishList = countriesWishListIds.split(',').map((id) => +id)

  const active = searchParams.get('active')
  if (active) filters.active = active === 'true'

  const accountActive = searchParams.get('accountActive')
  if (accountActive) filters.accountActive = accountActive === 'true'

  const countries = searchParams.getAll('countries')
  if (countries) filters.countries = countries

  const formulaIds = searchParams.get('formulaIds')
  if (formulaIds) filters.formulaIds = formulaIds.split(',').map((id) => +id)

  const maxAge = searchParams.get('maxAge')
  if (maxAge) filters.maxAge = +maxAge

  const minAge = searchParams.get('minAge')
  if (minAge) filters.minAge = +minAge

  const periodIds = searchParams.get('periodIds')
  if (periodIds) filters.periodIds = periodIds.split(',').map((id) => +id)

  const accomodations = searchParams.get('accomodations')
  if (accomodations) filters.accomodations = accomodations.split(',') as AccomodationEnum[]

  const transportMeansIds = searchParams.get('transportMeansIds')
  if (transportMeansIds) filters.transportMeansIds = transportMeansIds.split(',').map((id) => +id)

  const availabilityStart = searchParams.get('availability_start')
  const availabilityEnd = searchParams.get('availability_end')
  if (availabilityStart && availabilityEnd)
    filters.availability = {
      startDate: availabilityStart,
      endDate: availabilityEnd
    }

  const departureStart = searchParams.get('departure_start')
  const departureEnd = searchParams.get('departure_end')
  if (departureStart && departureEnd)
    filters.departure = { startDate: departureStart, endDate: departureEnd }

  const arrivalStart = searchParams.get('arrival_start')
  const arrivalEnd = searchParams.get('arrival_end')
  if (arrivalStart && arrivalEnd)
    filters.arrival = { startDate: arrivalStart, endDate: arrivalEnd }

  const stayStart = searchParams.get('stay_start')
  const stayEnd = searchParams.get('stay_end')
  if (stayStart && stayEnd) filters.stay = { startDate: stayStart, endDate: stayEnd }

  const excludedStaffIds = searchParams.get('excludedStaffIds')
  if (excludedStaffIds && excludedStaffIds.length)
    filters.excludedStaffIds = excludedStaffIds.split(',').map((id) => +id)

  const staffRequestId = searchParams.get('staffRequestId')
  if (staffRequestId && staffRequestId.length) filters.staffRequestId = +staffRequestId

  const deactivated = searchParams.get('deactivated')
  if (deactivated) filters.deactivated = deactivated === 'true'

  return filters
}
